//#region src/entry/core/script-loader.ts
var e = class extends HTMLElement {
	constructor() {
		super(), this.assetMap = JSON.parse(this.querySelector("script")?.textContent || "{}");
	}
	connectedCallback() {
		let e = this.parentNode;
		e && Object.keys(this.assetMap).length && (this.findCustomElements(e), this.observeMutations(e));
	}
	findCustomElements(e) {
		[e, ...Array.from(e.querySelectorAll("*"))].forEach((e) => {
			let t = e.localName;
			if (t.includes("-") && !customElements.get(t)) {
				let n = e.getAttribute("needs-script");
				n && (t = n), this.load(t);
			}
		});
	}
	observeMutations(e) {
		this.observer = new MutationObserver((e) => {
			e.forEach(({ addedNodes: e }) => {
				e.forEach((e) => {
					e.nodeType === Node.ELEMENT_NODE && this.findCustomElements(e);
				});
			});
		}), this.observer.observe(e, {
			childList: !0,
			subtree: !0
		});
	}
	load(e) {
		let t = this.assetMap[e];
		if (!t || document.querySelector(`script[src="${t}"]`)) return;
		let n = document.createElement("script");
		n.src = t, n.type = "module", document.body.appendChild(n);
	}
};
customElements.define("script-loader", e);
//#endregion
